<div class="tw-flex tw-flex-col tw-w-full tw-overflow-hidden">
  <div
    class="desktop-scheduler-scroll event-scheduler__scroll-max-height tw-overflow-hidden tw-relative tw-hidden md:tw-flex tw-w-full tw-border tw-border-gray-200 tw-rounded-lg"
  >
    <div class="event-scheduler__scroll-max-height tw-flex tw-h-full tw-overflow-y-auto tw-overflow-x-hidden tw-w-full">
      <div class="event-scheduler__time-axis tw-flex-shrink-0 tw-flex tw-flex-col tw-border-r tw-border-gray-200 tw-h-full">
        <div class="tw-min-h-9 tw-sticky tw-top-0 tw-z-40 tw-bg-white tw-border-b tw-border-gray-200"></div>
        @for (row of dayRows(); track row.id) {
          <div
            class="event-scheduler__day-row tw-flex tw-flex-col tw-gap-3 tw-p-3 tw-border-gray-200"
            [class.tw-border-t]="!$first"
            [class.tw-opacity-75]="!row.enabled && !isDayTimingsSaving(row.id)"
            [class.tw-pointer-events-none]="isDayTimingsSaving(row.id)"
            [class.tw-opacity-60]="isDayTimingsSaving(row.id)"
          >
            <div class="tw-flex tw-items-center tw-gap-2">
              <span class="tw-text-sm tw-font-medium tw-text-gray-500"> D{{ row.dayNumber }} </span>
              <div class="event-scheduler__hairline-v tw-min-h-4 tw-bg-gray-200"></div>
              <span
                class="tw-text-sm tw-text-gray-700 tw-font-medium tw-min-w-0 tw-truncate"
                [class.tw-text-gray-900]="row.enabled"
                [class.tw-text-gray-500]="!row.enabled"
              >{{ row.label }}</span>
              <button
                type="button"
                role="switch"
                [attr.aria-checked]="row.enabled"
                [attr.aria-busy]="isDayTimingsSaving(row.id)"
                (click)="onDayToggle(row.id, row.dayNumber, !row.enabled)"
                class="tw-ml-auto tw-relative tw-inline-flex tw-h-5 tw-w-10 tw-shrink-0 tw-rounded-full tw-border tw-border-transparent tw-p-0.5 tw-transition-colors tw-duration-200 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-blue-500 focus-visible:tw-ring-offset-1"
                [class.tw-cursor-pointer]="!isDayTimingsSaving(row.id)"
                [class.tw-cursor-not-allowed]="isDayTimingsSaving(row.id)"
                [class.tw-bg-blue-200]="isDayAddSlotSavingUi(row.id)"
                [class.tw-bg-blue-600]="row.enabled && !isDayAddSlotSavingUi(row.id)"
                [class.tw-bg-gray-300]="!row.enabled && !isDayAddSlotSavingUi(row.id)"
              >
                <span
                  class="tw-pointer-events-none tw-absolute tw-left-0.5 tw-top-1/2 -tw-translate-y-1/2 tw-inline-block tw-h-4 tw-w-4 tw-transform tw-rounded-full tw-bg-white tw-shadow tw-ring-0 tw-transition tw-duration-200"
                  [class.tw-translate-x-5]="row.enabled"
                  [class.tw-translate-x-0]="!row.enabled"
                ></span>
              </button>
            </div>
            <input
              type="text"
              [value]="row.note"
              (blur)="onNoteBlur(row.id, $any($event.target).value)"
              [disabled]="isDayTimingsSaving(row.id)"
              placeholder="Highlight note (e.g. gala dinner)"
              class="tw-w-full tw-h-12 tw-text-sm tw-rounded tw-border tw-px-3 tw-py-2 tw-border-gray-200 tw-bg-white tw-placeholder-gray-400 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500 focus:tw-border-blue-500"
            />
          </div>
        }
      </div>
      <div class="tw-flex tw-flex-1 tw-min-w-0 tw-flex-col tw-relative tw-h-full">
        <div class="tw-h-9 tw-sticky tw-top-0 tw-z-40 tw-bg-white tw-border-b tw-border-gray-200">
          <div class="tw-h-9 tw-w-full tw-overflow-hidden">
            <div class="hours-container tw-border-l tw-flex" [style.transform]="timelineHeaderTranslateX()">
              @for (hour of hourColumns(); track hour) {
                <div class="event-scheduler__hour-col tw-flex-shrink-0 tw-text-center tw-items-center tw-text-xs tw-text-gray-500 tw-py-2 tw-font-medium tw-border-r tw-border-gray-200 last:tw-border-r-0 tw-h-9">
                  {{ timeLabel(hour) }}
                </div>
              }
            </div>
          </div>
        </div>
        <div #gridRef class="tw-flex-1 tw-min-w-0 tw-overflow-x-auto tw-border-l tw-border-gray-200">
        <!-- 24 columns × 62px = 1488px so slot % positioning has a fixed reference -->
        <div #timelineRef class="tw-inline-flex tw-flex-col hours-container">
          <!-- Day rows: each row = one day, 24 hour cells + slot overlay -->
          @for (row of dayRows(); track row.id) {
            <div
              [class.tw-border-b]="!$last"
              class="event-scheduler__day-row tw-relative tw-flex tw-border-gray-200 tw-overflow-visible tw-box-content"
              [class.tw-pointer-events-none]="isDayTimingsSaving(row.id)"
            >
              @for (hour of hourColumns(); track hour) {
                <div
                  class="event-scheduler__hour-col tw-flex-shrink-0 tw-relative tw-border-r tw-border-gray-200 tw-box-border tw-z-0"
                  (mouseenter)="onCellHover(row.id, hour, true)"
                  (mouseleave)="onCellHover(row.id, hour, false)"
                >
                  @if (row.enabled && !resizing() && !isDayTimingsSaving(row.id) && isHovered(row.id, hour) && !slotCoversHour(row.slots, hour)) {
                    <button
                      type="button"
                      (click)="onAddSlotClick(row.id, hour)"
                      [ngxTippy]="'Add time slot'"
                      [tippyProps]="addSlotTippyProps"
                      class="event-scheduler__add-slot-hit-inner tw-absolute tw-inset-0.5 tw-flex tw-items-center tw-justify-center tw-border-2 tw-border-dashed tw-border-gray-300 tw-rounded tw-bg-gray-50 hover:tw-border-blue-400 hover:tw-bg-blue-50 tw-text-gray-400 hover:tw-text-blue-600 tw-transition-colors"
                      aria-label="Add time slot"
                    >
                      <span class="tw-text-xl tw-font-light">+</span>
                    </button>
                  }
                </div>
              }
              @if (!row.enabled) {
                <!-- Inactive day: faded block spanning active time range with message -->
                <div
                  class="desktop-inactive-day event-scheduler__inactive-overlay tw-absolute tw-top-1 tw-bottom-1 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-blue-200 tw-rounded-lg tw-pointer-events-none"
                >
                  <div class="tw-w-full tw-h-full tw-py-2 tw-max-w-full">
                    <p class="tw-text-sm tw-font-bold tw-text-gray-500">Inactive day</p>
                    <p class="tw-text-xs tw-font-medium tw-text-gray-500">No check-ins or check-outs will be accepted on this day, and it will not be included in the event's reports.</p>
                  </div>
                </div>
              } @else {
                <!-- Slot blocks positioned by time on the 24h axis (above cells) -->
                <div class="tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-right-0 tw-w-full tw-h-full tw-z-10 tw-pointer-events-none">
                  @for (slot of (row.slots ?? []); track slotTrackKey(slot)) {
                    @if (slotTime(slot).start && slotTime(slot).end && !isSlotHiddenDuringAddSave(row.id, slot)) {
                      <app-dropdown
                        class="app-event-scheduler-slot-move event-scheduler__slot-dropdown tw-absolute tw-top-2 tw-z-10 tw-block tw-overflow-visible"
                        [class.tw-pointer-events-auto]="!isDayTimingsSaving(row.id)"
                        [ngClass]="{
                          '!tw-transition-none':
                            isSlotPreviewActive(row.id, $index) ||
                            disableSlotLayoutTransition() ||
                            isSlotJustAdded(row.id, slot)
                        }"
                        [style.left.%]="slotPositionWithPreview(row, slot, $index).left"
                        [style.width.%]="slotPositionWithPreview(row, slot, $index).width"
                        [style.minWidth.px]="28"
                        [dropdownOptions]="slotMenuOptionsFor(row)"
                        [widthInPX]="'132px'"
                        [heightInPX]="96"
                        [minWidthInPX]="'120px'"
                        [dropdownListYPosition]="'bottom'"
                        [dropdownListXPosition]="'auto'"
                        [positionAtClick]="true"
                        (dropdownOpened)="onSlotMenuOpened(row.id, $index)"
                        (dropdownClosed)="onSlotMenuClosed(row.id, $index)"
                        (optionClicked)="onSlotMenuOption(row.id, $index, $event)"
                      >
                        <div
                          class="tw-flex tw-h-full tw-w-full tw-items-center tw-rounded-lg tw-text-xs tw-shadow-sm tw-relative tw-overflow-visible tw-transition-colors tw-duration-150"
                          [ngClass]="[
                            isDayAddSlotSavingUi(row.id)
                              ? 'tw-bg-blue-200 tw-text-gray-700'
                              : isSlotMenuOpen(row.id, $index)
                                ? 'tw-text-white tw-bg-blue-600 hover:tw-bg-blue-600 focus-within:tw-bg-blue-600 focus-within:tw-shadow-none'
                                : 'tw-text-white tw-bg-blue-700 hover:tw-bg-blue-800 focus-within:tw-bg-blue-800 event-scheduler__slot-focus-ring',
                            slotRadiusClass(row.id, slot)
                          ]"
                          [ngxTippy]="isDayAddSlotSavingUi(row.id) ? '' : (slotDetailTippyContent(row, slot, $index) ?? '')"
                          [tippyProps]="tippyPropsForSlot(row, slot, $index)"
                        >
                        <!-- Left resize handle: drag left = earlier start (decrease), drag right = later start (increase) -->
                        <div
                          class="event-scheduler__resize-handle-x tw-pointer-events-auto tw-relative tw-flex tw-h-full tw-shrink-0 tw-cursor-ew-resize tw-items-center tw-justify-center tw-bg-transparent tw-rounded-l"
                          (mousedown)="startResize(row.id, $index, $event)"
                          (click)="$event.stopPropagation()"
                          title="Drag to resize start (30 min steps)"
                        >
                          <svg width="5" height="20" viewBox="0 0 5 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0.5" y1="0.5" x2="0.499999" y2="19.5" stroke-linecap="round" [attr.stroke]="isDayAddSlotSavingUi(row.id) ? '#4B5563' : 'white'"/>
                            <line x1="2.5" y1="0.5" x2="2.5" y2="19.5" stroke-linecap="round" [attr.stroke]="isDayAddSlotSavingUi(row.id) ? '#4B5563' : 'white'"/>
                            <line x1="4.5" y1="0.5" x2="4.5" y2="19.5" stroke-linecap="round" [attr.stroke]="isDayAddSlotSavingUi(row.id) ? '#4B5563' : 'white'"/>
                          </svg>
                        </div>
                        <div
                          class="tw-flex tw-flex-col tw-justify-center tw-h-full tw-flex-1 tw-px-2 tw-py-1 tw-truncate tw-min-w-0 tw-cursor-move tw-select-none"
                          [title]="slotFallbackTitle(row, slot, $index)"
                          (mousedown)="onSlotBodyMouseDown(row.id, $index, $event)"
                        >
                          <div
                            class="tw-font-bold tw-text-sm tw-truncate"
                            [class.tw-text-white]="!isDayAddSlotSavingUi(row.id)"
                            [class.tw-text-gray-800]="isDayAddSlotSavingUi(row.id)"
                          >
                            {{ slotDayHeader(row) }}
                          </div>
                          <div
                            class="tw-font-medium tw-text-xs tw-truncate"
                            [class.tw-text-white]="!isDayAddSlotSavingUi(row.id)"
                            [class.tw-text-gray-700]="isDayAddSlotSavingUi(row.id)"
                          >
                            {{ slotTimeDisplay(row, slot, $index).start }} - {{ slotTimeDisplay(row, slot, $index).end }}
                          </div>
                        </div>
                        <!-- Right resize handle: drag right = later end (increase), drag left = earlier end (decrease) -->
                        <div
                          class="event-scheduler__resize-handle-x tw-pointer-events-auto tw-relative tw-flex tw-h-full tw-shrink-0 tw-cursor-ew-resize tw-items-center tw-justify-center tw-bg-transparent tw-rounded-r"
                          (mousedown)="endResize(row.id, $index, $event)"
                          (click)="$event.stopPropagation()"
                          title="Drag to resize end (30 min steps)"
                        >
                          <svg width="5" height="20" viewBox="0 0 5 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0.5" y1="0.5" x2="0.499999" y2="19.5" stroke-linecap="round" [attr.stroke]="isDayAddSlotSavingUi(row.id) ? '#4B5563' : 'white'"/>
                            <line x1="2.5" y1="0.5" x2="2.5" y2="19.5" stroke-linecap="round" [attr.stroke]="isDayAddSlotSavingUi(row.id) ? '#4B5563' : 'white'"/>
                            <line x1="4.5" y1="0.5" x2="4.5" y2="19.5" stroke-linecap="round" [attr.stroke]="isDayAddSlotSavingUi(row.id) ? '#4B5563' : 'white'"/>
                          </svg>
                        </div>
                        </div>
                      </app-dropdown>
                    }
                  }
                  @if (addingSkeletonSlot(row.id); as sk) {
                    <div
                      class="event-scheduler__new-slot-skeleton tw-absolute tw-top-2 tw-bottom-2 tw-z-20 tw-flex tw-flex-col tw-rounded-lg tw-pointer-events-none tw-overflow-hidden tw-border tw-border-blue-300 tw-bg-blue-100 tw-animate-pulse"
                      [style.left.%]="slotPosition(sk).left"
                      [style.width.%]="slotPosition(sk).width"
                      [style.minWidth.px]="28"
                      role="status"
                      aria-label="Saving new time slot"
                    >
                      <div class="tw-flex tw-h-full tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col tw-justify-center tw-gap-1.5 tw-px-2 tw-py-1">
                        <div class="tw-h-2 tw-w-[72%] tw-max-w-full tw-shrink-0 tw-rounded tw-bg-blue-200/90"></div>
                        <div class="tw-h-2 tw-w-[48%] tw-max-w-full tw-shrink-0 tw-rounded tw-bg-blue-200/70"></div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
        </div>
      </div>
    </div>
    <!-- Always-visible scrollbar overlay for the timeline section (macOS can auto-hide native scrollbars) -->
    <div
      #hScrollTrackRef
      class="horizontal-scrollbar tw-group tw-absolute tw-h-4 tw-cursor-pointer tw-select-none tw-px-2.5 tw-py-1.5 tw-right-0 tw-bottom-0 tw-z-30"
      (mousedown)="onAlwaysScrollbarMouseDown($event)"
      role="scrollbar"
      aria-label="Timeline horizontal scroll"
    >
      <div class="tw-relative tw-h-2 tw-w-full tw-rounded-full">
        <div
          class="tw-absolute tw-top-0 tw-h-2 tw-rounded-full tw-bg-gray-400 tw-group-hover:tw-bg-gray-500"
          [style.width.%]="alwaysScrollbarThumbWidthPct()"
          [style.left.%]="alwaysScrollbarThumbLeftPct()"
        ></div>
      </div>
    </div>
  </div>

  <!-- Mobile (&lt; md): day chips + selected-day card -->
  <div class="tw-flex md:tw-hidden tw-flex-col tw-w-full tw-gap-4">
    <div class="event-scheduler__mobile-chips-scroll tw-flex tw-gap-2 tw-overflow-x-auto tw-pb-1 tw--mx-1 tw-px-1">
      @for (d of dayRows(); track d.id) {
        <button
          type="button"
          class="event-scheduler__mobile-day-chip tw-flex tw-min-w-14 tw-shrink-0 tw-flex-col tw-items-center tw-justify-center tw-rounded-xl tw-border tw-bg-gray-50 tw-px-3 tw-py-2 tw-font-inter tw-transition-colors"
          [ngClass]="
            selectedMobileDayId() === d.id
              ? 'tw-border-blue-600 tw-bg-blue-50'
              : 'tw-border-gray-100 tw-bg-white'
          "
          [class.tw-bg-gray-200]="!d.enabled"
          (click)="selectMobileDay(d.id)"
        >
          <span
            class="tw-text-lg tw-font-semibold tw-leading-tight"
            [ngClass]="!d.enabled ? 'tw-text-gray-400' : selectedMobileDayId() === d.id ? 'tw-text-blue-600' : 'tw-text-gray-900'"
            >{{ dayChipDayNumber(d) }}</span>
          <span
            class="tw-text-xs tw-font-medium"
            [ngClass]="!d.enabled ? 'tw-text-gray-400' : selectedMobileDayId() === d.id ? 'tw-text-blue-600' : 'tw-text-gray-600'"
            >{{ dayChipWeekday(d) }}</span>
        </button>
      }
    </div>

    @if (mobileSelectedRow(); as row) {
      <div
        class="tw-flex tw-flex-col tw-gap-6 tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white tw-p-4"
        [class.tw-pointer-events-none]="isDayTimingsSaving(row.id)"
        [class.tw-opacity-60]="isDayTimingsSaving(row.id)"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
          <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
            <span class="tw-text-base tw-font-inter tw-font-medium tw-text-gray-500 tw-shrink-0">D{{ row.dayNumber }}</span>
            <div class="event-scheduler__hairline-v tw-min-h-4 tw-bg-gray-200 tw-shrink-0"></div>
            <span
              class="tw-text-base tw-text-gray-700 tw-font-inter tw-font-medium tw-truncate"
              >{{ row.label }}</span>
          </div>
          <button
            type="button"
            role="switch"
            [attr.aria-checked]="row.enabled"
            [attr.aria-busy]="isDayTimingsSaving(row.id)"
            (click)="onDayToggle(row.id, row.dayNumber, !row.enabled)"
            class="tw-relative tw-inline-flex tw-h-6 tw-w-11 tw-shrink-0 tw-rounded-full tw-border tw-border-transparent tw-p-0.5 tw-transition-colors tw-duration-200 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-blue-500 focus-visible:tw-ring-offset-1"
            [class.tw-cursor-pointer]="!isDayTimingsSaving(row.id)"
            [class.tw-cursor-not-allowed]="isDayTimingsSaving(row.id)"
            [class.tw-bg-blue-200]="isDayAddSlotSavingUi(row.id)"
            [class.tw-bg-blue-600]="row.enabled && !isDayAddSlotSavingUi(row.id)"
            [class.tw-bg-gray-300]="!row.enabled && !isDayAddSlotSavingUi(row.id)"
          >
            <span
              class="tw-pointer-events-none tw-absolute tw-left-0.5 tw-top-1/2 -tw-translate-y-1/2 tw-inline-block tw-h-5 tw-w-5 tw-transform tw-rounded-full tw-bg-white tw-shadow tw-ring-0 tw-transition tw-duration-200"
              [class.tw-translate-x-5]="row.enabled"
              [class.tw-translate-x-0]="!row.enabled"
            ></span>
          </button>
        </div>

        @if (!row.enabled) {
          <div class="tw-rounded-lg tw-bg-blue-200 tw-p-3 tw-text-gray-500">
            <p class="tw-text-sm tw-font-medium tw-text-gray-500">Inactive day</p>
          </div>
        } @else {
          <div class="tw-flex tw-flex-col tw-gap-3">
            @if (addingSkeletonSlot(row.id)) {
              <div
                class="tw-flex tw-min-h-12 tw-h-12 tw-flex-col tw-justify-center tw-rounded-lg tw-border tw-border-blue-300 tw-bg-blue-100 tw-animate-pulse tw-gap-2 tw-px-3 tw-shadow-sm"
                role="status"
                aria-label="Saving new time slot"
              >
                <div class="tw-h-2.5 tw-w-full tw-max-w-[10rem] tw-shrink-0 tw-rounded tw-bg-blue-200/90"></div>
                <div class="tw-h-2.5 tw-w-2/3 tw-max-w-full tw-shrink-0 tw-rounded tw-bg-blue-200/70"></div>
              </div>
            }
            @for (slot of row.slots ?? []; track $index) {
              @if (slotTime(slot).start && slotTime(slot).end && !isSlotHiddenDuringAddSave(row.id, slot)) {
                <div
                  class="tw-flex tw-h-12 tw-items-center tw-justify-between tw-gap-1 tw-rounded-lg tw-px-3 tw-py-1 tw-shadow-sm"
                  [ngClass]="[
                    isDayAddSlotSavingUi(row.id)
                      ? 'tw-bg-blue-200 tw-text-gray-800'
                      : 'tw-bg-blue-700 tw-text-white',
                    slotRadiusClass(row.id, slot)
                  ]"
                >
                  <span class="tw-flex-1 tw-min-w-0 tw-text-sm tw-font-medium tw-font-inter">
                    {{ slotTimeDisplay(row, slot, $index).start }} - {{ slotTimeDisplay(row, slot, $index).end }}
                  </span>
                  <div class="tw-flex tw-items-center">
                    <button
                      type="button"
                      class="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-items-center tw-justify-center disabled:tw-opacity-40"
                      aria-label="Edit time slot"
                      [disabled]="isDayTimingsSaving(row.id)"
                      (click)="slotEditOpen.emit({ dayId: row.id, slotIndex: $index })"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.4516 0.621206L11.1745 1.97018L14.1146 5.07562L15.391 3.72665C15.584 3.52276 15.7372 3.2807 15.8417 3.01428C15.9462 2.74786 16 2.4623 16 2.17393C16 1.88555 15.9462 1.6 15.8417 1.33358C15.7372 1.06716 15.584 0.825093 15.391 0.621206C14.9948 0.222442 14.4685 0 13.9213 0C13.374 0 12.8478 0.222442 12.4516 0.621206Z" [attr.fill]="isDayAddSlotSavingUi(row.id) ? '#374151' : 'white'"/>
                        <path d="M12.9389 6.31744L9.99872 3.212L6.06991 7.35815C5.95367 7.4807 5.87439 7.63686 5.84208 7.80693L5.40471 10.136C5.37781 10.2778 5.38448 10.4245 5.42413 10.5629C5.46379 10.7014 5.53521 10.8273 5.63204 10.9296C5.72888 11.0319 5.84812 11.1073 5.9792 11.1492C6.11027 11.1911 6.24911 11.1981 6.38338 11.1697L8.5885 10.7042C8.74923 10.6699 8.89677 10.5862 9.01257 10.4636L12.9389 6.31744Z" [attr.fill]="isDayAddSlotSavingUi(row.id) ? '#374151' : 'white'"/>
                        <path d="M6.06991 7.35815C5.95367 7.4807 5.87439 7.63686 5.84208 7.80693L5.40471 10.136C5.37781 10.2778 5.38448 10.4245 5.42413 10.5629C5.46379 10.7014 5.53521 10.8273 5.63204 10.9296C5.72888 11.0319 5.84812 11.1073 5.9792 11.1492C6.11027 11.1911 6.24911 11.1981 6.38338 11.1697L8.5885 10.7042C8.74923 10.6699 8.89677 10.5862 9.01257 10.4636L12.9389 6.31744L9.99872 3.212L6.06991 7.35815Z" [attr.fill]="isDayAddSlotSavingUi(row.id) ? '#374151' : 'white'"/>
                        <path d="M9.80581 11.4894C9.57348 11.7344 9.27787 11.9015 8.95602 11.9698L6.01586 12.5907C5.74746 12.6473 5.46997 12.6331 5.20802 12.5493C4.94607 12.4655 4.70776 12.3147 4.51422 12.1103C4.32068 11.9058 4.17791 11.6541 4.09856 11.3774C4.01921 11.1008 4.00574 10.8077 4.05935 10.5242L4.64722 7.41876C4.7119 7.07881 4.87012 6.76659 5.10205 6.5212L9.193 2.20028C9.17025 2.1184 9.15849 2.03355 9.15808 1.94822H1.80185C1.3241 1.94869 0.866052 2.14935 0.528235 2.50615C0.190419 2.86296 0.000440318 3.34676 0 3.85136V14.0969C0.000440318 14.6015 0.190419 15.0853 0.528235 15.4421C0.866052 15.7989 1.3241 15.9995 1.80185 16H11.5021C11.9798 15.9995 12.4379 15.7989 12.7757 15.4421C13.1135 15.0853 13.3035 14.6015 13.3039 14.0969V7.79464L9.80581 11.4894Z" [attr.fill]="isDayAddSlotSavingUi(row.id) ? '#374151' : 'white'"/>
                      </svg>
                    </button>
                    <button
                      type="button"
                      class="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-items-center tw-justify-center disabled:tw-opacity-40"
                      aria-label="Remove time slot"
                      [disabled]="isDayTimingsSaving(row.id)"
                      (click)="onMobileRemoveSlot(row.id, $index)"
                    >
                      <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.8519 3.36842H10.5926V1.68421C10.5926 1.23753 10.4209 0.809144 10.1153 0.493294C9.80967 0.177443 9.39517 0 8.96296 0H5.7037C5.2715 0 4.857 0.177443 4.55138 0.493294C4.24577 0.809144 4.07407 1.23753 4.07407 1.68421V3.36842H0.814815C0.598713 3.36842 0.391461 3.45714 0.238654 3.61507C0.0858463 3.77299 0 3.98719 0 4.21053C0 4.43387 0.0858463 4.64806 0.238654 4.80598C0.391461 4.96391 0.598713 5.05263 0.814815 5.05263H1.62963V14.3158C1.62963 14.7625 1.80132 15.1909 2.10694 15.5067C2.41255 15.8226 2.82705 16 3.25926 16H11.4074C11.8396 16 12.2541 15.8226 12.5597 15.5067C12.8653 15.1909 13.037 14.7625 13.037 14.3158V5.05263H13.8519C14.068 5.05263 14.2752 4.96391 14.428 4.80598C14.5808 4.64806 14.6667 4.43387 14.6667 4.21053C14.6667 3.98719 14.5808 3.77299 14.428 3.61507C14.2752 3.45714 14.068 3.36842 13.8519 3.36842ZM5.7037 1.68421H8.96296V3.36842H5.7037V1.68421ZM6.51852 12.6316C6.51852 12.8549 6.43267 13.0691 6.27986 13.227C6.12706 13.385 5.91981 13.4737 5.7037 13.4737C5.4876 13.4737 5.28035 13.385 5.12754 13.227C4.97474 13.0691 4.88889 12.8549 4.88889 12.6316V6.73684C4.88889 6.5135 4.97474 6.29931 5.12754 6.14138C5.28035 5.98346 5.4876 5.89474 5.7037 5.89474C5.91981 5.89474 6.12706 5.98346 6.27986 6.14138C6.43267 6.29931 6.51852 6.5135 6.51852 6.73684V12.6316ZM9.77778 12.6316C9.77778 12.8549 9.69193 13.0691 9.53912 13.227C9.38632 13.385 9.17906 13.4737 8.96296 13.4737C8.74686 13.4737 8.53961 13.385 8.3868 13.227C8.23399 13.0691 8.14815 12.8549 8.14815 12.6316V6.73684C8.14815 6.5135 8.23399 6.29931 8.3868 6.14138C8.53961 5.98346 8.74686 5.89474 8.96296 5.89474C9.17906 5.89474 9.38632 5.98346 9.53912 6.14138C9.69193 6.29931 9.77778 6.5135 9.77778 6.73684V12.6316Z" fill="#E02424"/>
                      </svg>
                    </button>

                  </div>
                </div>
              }
            }
          </div>
          <button
            type="button"
            class="tw-inline-flex tw-items-center tw-gap-1 tw-text-sm tw-font-medium tw-text-blue-600 hover:tw-text-blue-700 tw-font-inter disabled:tw-pointer-events-none disabled:tw-opacity-40"
            [disabled]="isDayTimingsSaving(row.id)"
            (click)="onMobileOpenAddSlotModal(row.id)"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.8889 8.88889H11.1111V1.11111C11.1111 0.816426 10.994 0.533811 10.7857 0.325437C10.5773 0.117063 10.2947 0 10 0C9.70532 0 9.4227 0.117063 9.21433 0.325437C9.00595 0.533811 8.88889 0.816426 8.88889 1.11111V8.88889H1.11111C0.816426 8.88889 0.533811 9.00595 0.325437 9.21433C0.117063 9.4227 0 9.70532 0 10C0 10.2947 0.117063 10.5773 0.325437 10.7857C0.533811 10.994 0.816426 11.1111 1.11111 11.1111H8.88889V18.8889C8.88889 19.1836 9.00595 19.4662 9.21433 19.6746C9.4227 19.8829 9.70532 20 10 20C10.2947 20 10.5773 19.8829 10.7857 19.6746C10.994 19.4662 11.1111 19.1836 11.1111 18.8889V11.1111H18.8889C19.1836 11.1111 19.4662 10.994 19.6746 10.7857C19.8829 10.5773 20 10.2947 20 10C20 9.70532 19.8829 9.4227 19.6746 9.21433C19.4662 9.00595 19.1836 8.88889 18.8889 8.88889Z" fill="#1C64F2"/>
            </svg>
            
            Add time slot
          </button>
        }

        <input
          type="text"
          [value]="row.note"
          (blur)="onNoteBlur(row.id, $any($event.target).value)"
          [disabled]="isDayTimingsSaving(row.id)"
          placeholder="Highlight note (e.g. gala dinner)"
          class="tw-w-full tw-h-12 tw-text-sm tw-rounded-lg tw-border tw-px-3 tw-py-2 tw-border-gray-200 tw-bg-white tw-placeholder-gray-400 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-blue-500 focus:tw-border-blue-500"
        />
      </div>
    }
  </div>

  <delete-modal
    [id]="confirmDeactivateModalId"
    [message]="
      'Are you sure you want to deactivate D' +
      (pendingDeactivateDay()?.dayNumber ?? '') +
      ' “' +
      (pendingDeactivateDay()?.label ?? '') +
      '” for your event days?'
    "
    (onDelete)="confirmDeactivateDay()"
    (onCancel)="cancelDeactivateDay()"
  ></delete-modal>
</div>
